module.exports = __webpack_public_path__ + "static/img/sw2.bb1882de.png";